import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./InquiryTitleBar.css";

class InquiryTitleBar extends Component {

    render() {
        return (
            <div className="row">
                <div className="col-md-4 remove-left-padding">
                    <div className="title-1 text-align-left">
                        <FormattedMessage id="app.admin-inquiry-title-bar.title"
                                          defaultMessage="INQUIRIES"
                                          description=""/>
                    </div>
                </div>
                <div className="col-md-8 remove-left-padding">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4">&nbsp;</div>
                            <div className="col-md-3 custom-col-3 text-right no-margin no-padding">
                                <label>
                                    <FormattedMessage id="app.admin-inquiry-title-bar.filter-by"
                                                      defaultMessage="Filter By:"
                                                      description=""/>
                                </label>
                                <span className="whiteSpaceElement">
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                </span>


                            </div>
                            <div className="col-md-2 no-padding-left">
                                ユーザー名
                            </div>
                            <div className="col-md-3 pull-left no-padding-left username-textbox-resp">
                                <input className="form-control search-input color-text"
                                       onChange={this.props.setSearchText}/>
                            </div>
                            <div className="brElement-add"></div>
                            {/*<div className="col-md-4 no-padding">*/}
                            {/*<div className="pull-right">*/}
                            {/*<input type="checkbox" value={1}*/}
                            {/*onChange={this.props.setSearchStatus}*/}
                            {/*defaultChecked={false}/>&nbsp;*/}
                            {/*<span>*/}
                            {/*<FormattedMessage id="app.admin-inquiry-title-bar.checkbox"*/}
                            {/*defaultMessage="Show unreplied only"*/}
                            {/*description=""/>*/}
                            {/*</span>*/}
                            {/*</div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InquiryTitleBar;




// WEBPACK FOOTER //
// ./src/components/Admin/Inquiry/InquiryTitleBar/InquiryTitleBar.js